import {
    FaArchive,
    FaBook,
    FaCode, FaCodeBranch,
    FaFile,
    FaHistory,
    FaHome,
    FaList,
    FaListAlt,
    FaPaste,
    FaPhoneSquare,
    FaRoad,
    FaShoppingCart,
    FaUsers
} from "react-icons/fa";
import {
    FaArrowRotateLeft,
    FaBriefcase,
    FaBuilding,
    FaBuildingColumns, FaChartLine,
    FaFileLines,
    FaGears, FaGift, FaGraduationCap, FaHandshake, FaListCheck,
    FaLocationDot,
    FaPhotoFilm,
    FaTableList,
    FaUserTie
} from "react-icons/fa6";
import React from "react";

export const menuResource = [
    {
        name: 'Dashboard', icon: <FaHome/>, permissions: ["dashboard_projects", "licenses_history", "dashboard_license", "dashboard_spider", "noc"],
        submenu: [
            {name: "Projetos", icon: <FaTableList />, link: "/", permissions: ["dashboard_projects", "licenses_history"]},
            {name: "Licenciamento", icon: <FaTableList />, link: "/dashboard-license", permissions: ["dashboard_license"]},
            {name: "Spider", icon: <FaTableList />, link: "/dashboard-spider", permissions: ["dashboard_spider"]},
            {name: "Câmeras de OCR", icon: <FaTableList />, link: "/dashboard-ocr", permissions: ["noc"]},
        ]
    },
    {
        name: 'Suporte', icon: <FaCode/>, permissions: ["control_attend", "support_release", "support_release2", "see_versions"],
        submenu: [
            {
                name: "Atendimentos",
                icon: <FaPhoneSquare/>,
                link: "/software-attendances",
                permissions: ["control_attend"]
            },
            {
                name: "Atualizações",
                icon: <FaArrowRotateLeft/>,
                link: "/release",
                permissions: ["support_release"]
            },
            {
                name: "Atualizações 2",
                icon: <FaArrowRotateLeft/>,
                link: "/release2",
                permissions: ["support_release2"]
            },
            {
                name: "Versões",
                icon: <FaCodeBranch/>,
                link: "/versions",
                permissions: ["see_versions"]
            },
        ]
    },
    {
        name: 'Infraestrutura', icon: <FaRoad/>, permissions: ["attendances", "orders"],
        submenu: [
            {name: "Atendimentos", icon: <FaPhotoFilm/>, link: "/hardware-attendances", permissions: ["attendances"]},
            {name: "Ordens de serviço", icon: <FaList/>, link: "/orders", permissions: ["orders"]},
        ]
    },
    {
        name: 'Cadastro',
        icon: <FaArchive/>,
        permissions: ["cities", "products", "resales", "user_system", "support", "technician"],
        submenu: [
            {name: "Projetos", icon: <FaBuildingColumns/>, link: "/projects", permissions: ["cities"]},
            {name: "Produtos", icon: <FaLocationDot/>, link: "/products", permissions: ["products"]},
            {name: "Revendas", icon: <FaShoppingCart/>, link: "/resales", permissions: ["resales"]},
            {name: "Usuário/Clientes", icon: <FaUsers/>, link: "/users", permissions: ["user_system"]},
            {name: "Templates", icon: <FaList/>, link: "/templates", permissions: ["support"]},
            {name: "Técnicos", icon: <FaUsers/>, link: "/technician", permissions: ["technician"]},
        ]
    },
    {
        name: 'Relatórios', icon: <FaPaste/>, permissions: ["reports_software_attendances", "reports_hardware_attendances", "reports_hardware_attendances_time", "reports_actions", "reports_noc", "reports_items", "reports_os_project", "reports_os_product", "reports_services_provided"],
        submenu: [
            {name: "Suporte - Atendimentos", icon: <FaHistory/>, link: "/reports/software-attendances", permissions: ["reports_software_attendances"]},
            {name: "Infraestrutura - Atendimentos", icon: <FaHistory/>, link: "/reports/hardware-attendances", permissions: ["reports_hardware_attendances"]},
            {name: "Infraestrutura - Tempo de atendimento", icon: <FaFile/>, link: "/reports/hardware-attendances-time", permissions: ["reports_hardware_attendances_time"]},
            {name: "Ações", icon: <FaFile/>, link: "/reports/actions", permissions: ["reports_actions"]},
            {name: "Noc", icon: <FaFile/>, link: "/reports/noc", permissions: ["reports_noc"]},
            {name: "Itens", icon: <FaFile/>, link: "/reports/items", permissions: ["reports_items"]},
            {name: "OS por projeto", icon: <FaFile/>, link: "/reports/os-project", permissions: ["reports_os_project"]},
            {name: "OS por produto", icon: <FaFile/>, link: "/reports/os-product", permissions: ["reports_os_product"]},
            {name: "Serviços prestados", icon: <FaFile/>, link: "/reports/services-provided", permissions: ["reports_services_provided"]},
        ]
    },
    {
        name: 'Chamados', icon: <FaPhoneSquare/>, permissions: ["user_project"],
        submenu: [
            {name: "Lista", icon: <FaListAlt/>, link: "/attendances", permissions: ["user_project"]},
        ]
    },
    {name: 'Solicitações', icon: <FaList/>, submenu: [], link: "/requests", permissions: ["request", "request_only_my_user"]},

    {name: 'Integrações', icon: <FaGears/>, submenu: [], link: "/integrations", permissions: ["integrations"]},

    {
        name: 'Pós-venda', icon: <FaHandshake/>, permissions: ["after_sales_attendances", "after_sales_trainings"],
        submenu: [
            {
                name: "Atendimentos",
                icon: <FaPhoneSquare/>,
                link: "/after-sales/attendances",
                permissions: ["after_sales_attendances"]
            },
            {name: "Treinamentos", icon: <FaBook/>, link: "/after-sales/trainings", permissions: ["after_sales_trainings"]},
        ]
    },

    {name: 'Controle de atividades', icon: <FaChartLine/>, permissions: ["activity_control", "activity_control_general"],
        submenu: [
            {
                name: "Cadastro",
                icon: <FaUsers/>,
                link: "/activity-control",
                permissions: ["activity_control"]
            },
            {name: "Acompanhamento", icon: <FaListCheck/>, link: "/activity-control/follow-up", permissions: ["activity_control_general"]},
            {name: "Organização de demandas", icon: <FaListCheck/>, link: "/activity-control/demands", permissions: ["activity_control_demands"]}
        ]
    },

    {name: 'Gestão de candidatos', icon: <FaFileLines/>, submenu: [
        {
            name: "Candidatos",
            icon: <FaUserTie/>,
            link: "/cv/candidates",
            permissions: ["cv_candidates", "cv_candidates_view_only"]
        },
        {
            name: "Beneficios",
            icon: <FaGift/>,
            link: "/cv/benefit",
            permissions: ["cv_candidates"]
        },
        {
            name: "Capacitações",
            icon: <FaGraduationCap/>,
            link: "/cv/qualification",
            permissions: ["cv_candidates"]
        },
        {
            name: "Departamentos",
            icon: <FaBuilding/>,
            link: "/cv/department",
            permissions: ["cv_candidates"]
        },
        {
            name: "Cargos",
            icon: <FaBriefcase/>,
            link: "/cv/position",
            permissions: ["cv_candidates"]
        },
        ] , permissions: ["cv_candidates", "cv_candidates_view_only"]

    }
]
